import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findFaturamento from '../../service/findFaturamento';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import postRelatorio from '../../service/postRelatorio';
import { FiltrarRelatorio } from '../../interface/FiltrarRelatorio';
import { Messages } from 'primereact/messages';
import putEstornarFaturamento from '../../service/putEstornarFaturamento';
import getResumoFaturamento from '../../service/getResumoFaturamento';
import patchGerarBoletoFaturamento from '../../service/patchGerarBoletoFaturamento';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';



export default function FaturamentoList() {
  const { t } = useTranslation();
  const [faturamentos, setFaturamentos] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const { state } = useGlobalState();
  const msgs = useRef<Messages>(null);
  const [dataReferencia, setDataReferencia] = useState<Nullable<Date | null>>(null);
  const [status, setStatus] = useState<Nullable<String | null>>(null);
  const [resumoVisible, setResumoVisible] = useState(false);
  const [resumoData, setResumoData] = useState<any[]>([]);
  const [estornoVisible, setEstornoVisible] = useState(false);
  const [estornoItem, setEstornoItem] = useState<any>(null);

  const statusList = [
    { label: 'Incluído', value: 'INCLUIDO' },
    { label: 'Processado', value: 'PROCESSADO' },
    { label: 'Processando', value: 'PROCESSANDO' },
    { label: 'Estornando', value: 'ESTORNANDO' },
    { label: 'Erro', value: 'ERRO' }
  ]

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    data: dataReferencia,
    status: status,
    idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'dataReferencia',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      data: dataReferencia,
      status: status,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      data: dataReferencia,
      status: status,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const imprimirInconsistencia = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_INCONSISTENCIA', tipoArquivo: 'PDF', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const imprimirEspelho = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_ESPELHO', tipoArquivo: 'CSV', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const confirmarEstorno = (item: any) => {
    setEstornoItem(item);
    setEstornoVisible(true);
  }

  const estornar = () => {
    if (!estornoItem) return;
    setEstornoVisible(false);
    putEstornarFaturamento(estornoItem).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }
        ]);
      }
      setEstornoItem(null);
      loadLazyData();
    });
  }

  const abrirResumo = (item: any) => {
    getResumoFaturamento(item.id).then((data) => {
      setResumoData(data);
      setResumoVisible(true);
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao buscar resumo do faturamento', closable: false }
        ]);
      }
    });
  }

  const gerarBoleto = (item: any) => {
    patchGerarBoletoFaturamento(item.id).then(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: 'Geração de boletos em andamento', closable: false }
        ]);
      }
      loadLazyData();
    }).catch(() => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: 'Erro ao gerar boletos', closable: false }
        ]);
      }
    });
  }

  const actionTemplate = (item: any) => {
    return <>
      {(item.status === 'PROCESSADO' || item.status === 'ENVIADO') && (<Button icon="pi pi-print" type="button" onClick={(e) => { imprimirEspelho(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      {(item.status === 'PROCESSADO' || item.status === 'ENVIADO') && (<Button icon="pi pi-ban" type="button" onClick={(e) => { imprimirInconsistencia(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      {item.status === 'PROCESSADO' && (<Button icon="pi pi-trash" type="button" onClick={() => { confirmarEstorno(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      {(item.status === 'PROCESSADO' || item.status === 'ENVIADO') && (<Button icon="pi pi-chart-bar" type="button" onClick={() => { abrirResumo(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} tooltip="Resumo" />)}
      {item.status === 'PROCESSADO' && state.user?.funcoes?.includes('FATURAMENTO_BOLETO') && (<Button icon="pi pi-file" type="button" onClick={() => { gerarBoleto(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} tooltip="Gerar Boletos" />)}
    </>
  }

  const dateBodyTemplate = (date: Nullable<Date>, hour:boolean) => {
    if (date) {
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: hour ? '2-digit' : undefined,
        minute: hour ? '2-digit' : undefined
      }).format(new Date(date));
    }

    return '';
  };

  const loadLazyData = () => {
    findFaturamento(lazyState).then(data => { setTotalRecords(data.total); setFaturamentos(data.faturamentos) }).catch(() => { setTotalRecords(0); setFaturamentos(undefined) });
  }

  const changeStatus = (stat: Nullable<String>) => {
    if (stat) {
      setStatus(stat);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataReferencia,
        status: stat,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const statusTemplate = (rowData: any) => {
    return (
      <Tag
        value={getStatusLabel(rowData.status)}
        severity={getStatusSeverity(rowData.status) as any}
      />
    );
  };
  const getStatusSeverity = (status: string) => {
    switch (status) {
      case 'PROCESSADO': return 'success';
      case 'INCLUIDO': return 'secondary';
      case 'PROCESSANDO': return 'info';
      default: return 'info';
    }
  };

  const getStatusLabel = (status: string) => {
    const labels: { [key: string]: string } = {
      'PROCESSADO': 'Processado',
      'INCLUIDO': 'Incluído',
      'PROCESSANDO': 'Processando'
    };
    return labels[status] || status;
  };

  const changeData = (dataRef: Nullable<Date>) => {
    if (dataRef) {
      setDataReferencia(dataRef);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataRef,
        status: status,
        idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const startContent = (
    <React.Fragment>
      <div style={{ background: 'transparent' }}>
        <div className="grid">

          <div className="col p-fluid flex flex-wrap">
            <div >
              <div className="flex-auto">
                <label htmlFor="data" className="font-bold block mb-2">{t('dataReferencia')} </label>
                <Calendar
                  id="data"
                  value={dataReferencia}
                  onChange={(e) => changeData(e.value)}
                  showIcon
                  dateFormat="mm/yy"
                  locale="pt"
                />
              </div>
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto" style={{ visibility: state.user.cliente ? 'hidden' : 'visible' }}>
                <label htmlFor="documento" className="font-bold block mb-2">
                  {t("status")}{" "}
                </label>
                <Dropdown disabled={state.user.cliente} style={{ width: '50%' }} value={status} onChange={(e) => { changeStatus(e.value) }} options={statusList} optionLabel="label" placeholder="Selecione Status"
                  showClear filter className="w-full md:w-14rem" />
              </div>
            </div>
          </div>



        </div>
      </div>
    </React.Fragment>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyState])

  return (
    <div>
      <Messages ref={msgs} />
      <Dialog header="Confirmação de Estorno" visible={estornoVisible} style={{ width: '30vw' }} onHide={() => setEstornoVisible(false)}
        footer={
          <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setEstornoVisible(false)} className="p-button-text" />
            <Button label="Confirmar Estorno" icon="pi pi-check" onClick={estornar} className="p-button-danger" />
          </div>
        }>
        {estornoItem && (
          <div>
            <p style={{ marginBottom: '0.5rem' }}><strong>Tem certeza que deseja estornar este faturamento?</strong></p>
            <p><strong>{t('dataReferencia')}:</strong> {formatDate(estornoItem.dataReferencia)}</p>
            <p><strong>{t('dataInicio')}:</strong> {formatDate(estornoItem.dataInicio)}</p>
            <p><strong>{t('dataFim')}:</strong> {formatDate(estornoItem.dataFim)}</p>
          </div>
        )}
      </Dialog>
      <Dialog header="Resumo do Faturamento" visible={resumoVisible} style={{ width: '70vw' }} onHide={() => setResumoVisible(false)}>
        <div className="flex-consulta  flex-wrap gap-3">
          {resumoData.map((item: any, index: number) => (
            <Card className='flex-1' style={{ backgroundColor: '#e6ffe6' }} key={index}>
              <div className="flex-consulta  justify-content-between gap-5">
                <div className="flex-consulta  flex-column gap-1">
                  <span style={{ color: '#008000' }} className=" text-sm">{item.label}</span>
                  <span style={{ color: '#008000' }} className="font-bold text-lg">{item.value}</span>
                </div>
                <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: '#008000', color: 'white' }}>
                  <i className={'pi ' + item.icon} />
                </span>
              </div>
            </Card>
          ))}
        </div>
      </Dialog>
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={faturamentos} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros"
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>
          <Column body={(e) => dateBodyTemplate(e.dataInclusao, true)} header={t('dataInclusao')} />
          <Column field='usuario' header={t('usuario')} />
          <Column field='status' header={t('status')} body={statusTemplate} />
          <Column body={(e) => dateBodyTemplate(e.dataReferencia, false)} header={t('dataReferencia')} />
          <Column body={(e) => dateBodyTemplate(e.dataVencimento, false)} header={t('dataVencimento')} />
          <Column body={(e) => dateBodyTemplate(e.dataInicio, false)} header={t('dataInicio')} />
          <Column body={(e) => dateBodyTemplate(e.dataFim, false)} header={t('dataFim')} />
         
          <Column body={actionTemplate} />
        </DataTable>
      </div>
    </div>
  )
}


